import { useQuery } from 'react-query';

import { getHeatMapMCTData } from 'api/InteractiveMap/getHeatMapMCTData';

export const useGetHeatMapTrapData = (planSlug: string, dateStart: string, dateEnd: string, type: string) => {
  const { data, refetch, isFetching } = useQuery(
    [`${type}heatMapData`, planSlug, dateStart, dateEnd],
    () => getHeatMapMCTData(planSlug, dateStart, dateEnd, type),
    {
      enabled: !!planSlug && !!dateStart && !!dateEnd,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  );

  return { data, refetch, isFetching };
};

export default useGetHeatMapTrapData;
